import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-design-partner-register',
  templateUrl: './design-partner-register.component.html',
  styleUrls: ['./design-partner-register.component.scss'],
})
export class DesignPartnerRegisterComponent implements OnInit {
  companyName: string = '';
  contactName: string = '';
  country: any = null;
  mobileNo: string = '';
  email: string = '';
  password: string = '';
  showPassword: boolean = false;
  certificatesManaged: string = '';
  countryOptions: any[] = [];
  isSubmitting: boolean = false;
  isSubmitted: boolean = false;
  validationErrors: Record<string, string> = {};

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private toaster: ToastService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.userService.getCountries().subscribe((data) => {
      this.countryOptions = data;
    });
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validateForm(): boolean {
    this.validationErrors = {};

    if (!this.companyName || this.companyName.trim().length < 2) {
      this.validationErrors['companyName'] = 'Company name is required';
    }

    if (!this.contactName || this.contactName.trim().length < 2) {
      this.validationErrors['contactName'] = 'Contact name is required';
    }

    if (!this.country) {
      this.validationErrors['country'] = 'Please select a country';
    }

    if (!this.mobileNo || this.mobileNo.trim().length === 0) {
      this.validationErrors['mobile'] = 'Mobile number is required';
    } else if (
      this.country &&
      this.mobileNo.length !== this.country.mobile_number_length
    ) {
      this.validationErrors['mobile'] = `Mobile number must be ${this.country.mobile_number_length} digits`;
    }

    if (!this.email || !this.isValidEmail(this.email)) {
      this.validationErrors['email'] = 'Please enter a valid email';
    }

    if (!this.password || this.password.length < 8) {
      this.validationErrors['password'] = 'Password must be at least 8 characters';
    }

    const certCount = Number(this.certificatesManaged);
    if (
      this.certificatesManaged === '' ||
      Number.isNaN(certCount) ||
      !Number.isInteger(certCount) ||
      certCount < 0
    ) {
      this.validationErrors['certificatesManaged'] =
        'Please enter a valid certificate count';
    }

    return Object.keys(this.validationErrors).length === 0;
  }

  hasError(field: string): boolean {
    return !!this.validationErrors[field];
  }

  submit(): void {
    if (!this.validateForm()) {
      const firstError = Object.values(this.validationErrors)[0];
      this.toaster.showToast(firstError, 'error');
      return;
    }

    this.isSubmitting = true;
    const payload = {
      company_name: this.companyName.trim(),
      contact_name: this.contactName.trim(),
      country_name: this.country.name,
      mobile_no: `${this.country.country_code}${this.mobileNo}`,
      email: this.email.trim().toLowerCase(),
      password: this.password,
      certificates_managed: Number(this.certificatesManaged),
    };

    this.authService.registerDesignPartner(payload).subscribe({
      next: () => {
        this.isSubmitted = true;
        this.isSubmitting = false;
        this.toaster.showToast(
          'Your registration request was submitted successfully.',
          'success'
        );
      },
      error: (error) => {
        this.isSubmitting = false;
        const message =
          error?.error?.message ||
          error?.error?.error ||
          'Oh uh! Something went wrong!';
        this.toaster.showToast(message, 'error');
      },
    });
  }

  togglePasswordVisibility(passwordInput: HTMLInputElement): void {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }

  navigateToLogin(): void {
    this.router.navigate(['/auth/login/design-partner']);
  }
}
